import { FetchError } from './FetchError';
import { FETCH_TRANSFORMER_ERROR_CODE } from 'utils';

/**
 * HTTP errors (4xx, 5xx status codes)
 *
 * @example
 * ```typescript
 * throw new HttpError('Bad Request', 400, { validation: 'email is invalid' });
 * ```
 */
export class HttpError extends FetchError {
  override readonly type = 'HttpError';

  constructor(message: string, statusCode: number, details?: Record<string, unknown>, cause?: Error) {
    super(message, FETCH_TRANSFORMER_ERROR_CODE.HTTP_ERROR, statusCode, details, cause);
  }
}
